import httpService from "./httpService";

export default {

  findAll: function (example) {
    return httpService.get("/userDeptRole/findAll", {params: example});
  },
  save(form) {
    return httpService.post("/userDeptRole", form)
  },
  update(form, id) {
    return httpService.put("/userDeptRole/" + id, form);
  },
  changeStatus(form, id) {
    return httpService.put(`/userDeptRole/${id}/changeStatus`, form);
  },
  delete(id) {
    return httpService.delete(`/userDeptRole/${id}`);
  },
  findById(id) {
    return httpService.get(`/userDeptRole/${id}`);
  },
  setToRoleMain(id) {
    return httpService.put(`/userDeptRole/${id}/setToRoleMain`);
  },

  updateForAccount(form) {
    return httpService.put(`/userDeptRole/updateForAccount`, form);
  }
}



// WEBPACK FOOTER //
// ./src/services/userDeptRoleService.js